export const AIDASH_PROVIDER_NAME = "aidash";

export const AIDASH_CARD_DISPLAY_NAME = "Biodiversity Net Gain by BNGAI™";
